import styled from 'styled-components';
import FilterOptions from './FilterOptions';

const Bar = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 1rem;
  padding: 1rem 4rem;
  background: #ffffff;
  border-bottom: 1px solid #e8ecef;

  @media (max-width: 1440px) {
    padding: 1rem 2rem;
  }

  @media (max-width: 768px) {
    padding: 1rem;
  }
`;

const CountText = styled.p`
  margin: 0;
  font-size: 0.875rem;
  color: #666666;
`;

const OptionsSlot = styled.div`
  display: flex;
  align-items: center;
  gap: 0.75rem;

  @media (max-width: 768px) {
    display: flex;
    width: 100%;
    justify-content: flex-start;
  }
`;

export default function ResultsToolbar({
  tipSheetCount,
  sortBy,
  setSortBy,
  clusterBy,
  setClusterBy,
  searchActive,
}) {
  return (
    <Bar>
      <CountText>
        Showing {tipSheetCount} Tip Sheet{tipSheetCount !== 1 ? 's' : ''}
      </CountText>
      <OptionsSlot>
        <FilterOptions
          variant="toolbar"
          sortBy={sortBy}
          setSortBy={setSortBy}
          clusterBy={clusterBy}
          setClusterBy={setClusterBy}
          searchActive={searchActive}
          isMobile={true}
        />
      </OptionsSlot>
    </Bar>
  );
}
